import moment from "moment";


// ─── WhatsApp Message Builder ───────────────────────────────────────────────
const buildWhatsAppMessage = ({ booking, branchName, restaurantName, restaurantMobile, restaurantAddress }) => {
    const hallName = branchName || restaurantName || "અમારો હોલ";
    const bookedBy = booking?.hostedBy || "-";
    const eventName = booking?.eventName || "-";
    const startDate = booking?.start ? moment(booking.start).format("DD/MM/YYYY") : "-";
    const startTime = booking?.start ? moment(booking.start).format("hh:mm A") : "-";
    const endTime = booking?.end ? moment(booking.end).format("hh:mm A") : "-";
    const persons = booking?.numberOfPersons || "-";
    const tables = booking?.tables && booking.tables.length > 0 ? booking.tables.map(t => t.tableNumber).join(", ") : "-";
    const menu = booking?.menuDetails || "-";
    const total = booking?.totalAmount ? `₹${booking.totalAmount}` : "-";
    const advance = booking?.advanceAmount ? `₹${booking.advanceAmount}` : "-";
    const pending =
        booking?.pendingAmount != null
            ? `₹${booking.pendingAmount}`
            : booking?.totalAmount != null && booking?.advanceAmount != null
                ? `₹${booking.totalAmount - booking.advanceAmount}`
                : "-";
    const decoration = booking?.decorationIncluded ? "બેઝિક ડેકોરેશન બુકિંગમાં સમાવિષ્ટ છે." : "બેઝિક ડેકોરેશન બુકિંગમાં સમાવિષ્ટ નથી.";
    const phone = restaurantMobile || "-";
    const address = restaurantAddress || "-";

    return `🎉 બુકિંગ કન્ફર્મેશન 🎉

આદરણીય ${bookedBy},

${hallName} પસંદ કરવા બદલ આપનો ખૂબ ખૂબ આભાર! આપનું બુકિંગ સફળતાપૂર્વક કન્ફર્મ થઈ ગયું છે. આપના પ્રસંગની વિગતો નીચે મુજબ છે:

📋 બુકિંગ વિગતો:
• પ્રસંગ : ${eventName}
• તારીખ: ${startDate}
• સમય: ${startTime} થી ${endTime}
• ટેબલ/હોલ: ${tables}
• મહેમાનોની સંખ્યા: ${persons}
• મેનૂ: ${menu}

💳 પેમેન્ટ વિગત:
• કુલ રકમ: ${total}
• મળેલી એડવાન્સ રકમ: ${advance}
• બાકી રકમ: ${pending}

📌 મહત્વપૂર્ણ સૂચનાઓ :
૧. ડેકોરેશન: ${decoration}
૨. બાકી રહેલી સંપૂર્ણ રકમ પ્રસંગના દિવસે ચૂકવવાની રહેશે.
૩. હોલનો ઉપયોગ નિર્ધારિત સમય મુજબ કરવાનો રહેશે. હોલ અથવા તેની કોઈપણ વસ્તુને થયેલ તૂટફૂટ, નુકસાન કે ખોટની ભરપાઈ બુકિંગ કરનાર દ્વારા કરવાની રહેશે.
૪. બુકિંગ રદ અથવા તારીખમાં ફેરફાર કરવાની જરૂરિયાત હોય તો કૃપા કરીને શક્ય તેટલી વહેલી તકે હોલ મેનેજમેન્ટને જાણ કરવા વિનંતી. લાગુ પડતી રકમ/સમાયોજન બુકિંગની શરતો અનુસાર કરવામાં આવશે.

કોઈપણ અન્ય માહિતી કે મદદ માટે નીચે આપેલા નંબર પર સંપર્ક કરી શકો છો. આપનો પ્રસંગ યાદગાર રહે તેવી શુભેચ્છા!

ધન્યવાદ,
${hallName}
📱 સંપર્ક નંબર: ${phone}
📍 સરનામું: ${address}`;
};

export default buildWhatsAppMessage;